export default class Cart {
	constructor(r) {
		this.item = {};
		if(r != false) {
			this.item = r;
		}

		this.defaults();
	}

	isset(key) {
		if(typeof this.item[key] === 'undefined') {
			return false;
		}

		return true;
	}

	output() {
		return this.item;
	}

	defaults() {
		if(!this.isset('paddingBottom')) {
			this.item.paddingBottom = '10px';
		}

		if(!this.isset('paddingTop')) {
			this.item.paddingTop = '10px';
		}


		if(!this.isset('width')) {
			this.item.width = '100%';
		}

		if(!this.isset('border_top')) {
			this.item.border_top = '2px|solid|#000000';
		}



		if(!this.isset('id')) {
			this.item.id = false;
		}

	}
}


// WEBPACK FOOTER //
// ./helpers/divider.js